import React, { useState } from "react";
import { Link } from "react-router-dom";

// Import Data
import offerings from "./offerings.js";
import team from "./team.js";

// Material UI Icons
import MenuIcon from "@material-ui/icons/Menu";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";

//Styles
import styles from "./landingpage.module.css";

function NavBar() {
    const [hamburger, setHamburger] = useState(false);

    return (
        <div className={styles.navigationContainer}>
            <img
                className={styles.left}
                src="./images/oneClick_black.svg"
                alt="oneClick logo"
            />
            <div className={styles.right}>
                <a href="#whyChooseUsContainer">Why Choose Us?</a>
                <a href="#ourTeamContainer">About Us</a>
                <a href="#contactUsContainer">Contact</a>
                <div>
                    <Link to="/login">Login</Link>
                    <Link to="/signup">Signup</Link>
                </div>
                <button
                    className={styles.hamburgerButton}
                    onClick={() => setHamburger(!hamburger)}
                >
                    {hamburger ? <MenuOpenIcon /> : <MenuIcon />}
                </button>
            </div>
            <div
                className={`${styles.collapsedMenu} ${
                    hamburger ? styles.display : styles.hidden
                }`}
            >
                <a href="#whyChooseUsContainer">Why Choose Us?</a>
                <a href="#ourTeamContainer">About Us</a>
                <a href="#contactUsContainer">Contact</a>
                <div>
                    <Link to="/login">Login</Link>
                    <Link to="/signup">Signup</Link>
                </div>
            </div>
        </div>
    );
}

function HeroSection() {
    return (
        <div
            className={styles.heroSectionContainer}
            style={{ backgroundImage: "url(./images/heroSection.svg)" }}
        >
            <div className={styles.heroSectionCTA}>
                <h1>Platform which connects you.</h1>
                <p>
                    with your peers and teachers and allow you to showcase your
                    projects and also become a part of other projects.
                </p>
                <Link to="/signup">Get Started</Link>
            </div>
        </div>
    );
}

function Offerings() {
    return (
        <div className={styles.offeringContainer}>
            <h2>Here's what we offer</h2>
            <p>OUR VALUES</p>
            <div className={styles.cardsContainer}>
                {offerings.map((each) => {
                    return (
                        <div className={styles.card}>
                            <img src={each.img} alt="" />
                            <h3>{each.title}</h3>
                            <p>{each.description}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function WhyChooseUs() {
    return (
        <div className={styles.whyChooseUsContainer} id="whyChooseUsContainer">
            <h2>Why Choose OneClick?</h2>
            <p>FEATURES</p>
            <div className={styles.content}>
                <img
                    className={styles.left}
                    src="./images/whyChooseUs.png"
                    alt=""
                />
                <div className={styles.right}>
                    <div className={styles.feature}>
                        <img src="./images/featuresTick.svg" alt="" />
                        Share Ideas
                    </div>
                    <div className={styles.feature}>
                        <img src="./images/featuresTick.svg" alt="" /> Notes and
                        Books
                    </div>
                    <div className={styles.feature}>
                        <img src="./images/featuresTick.svg" alt="" />{" "}
                        Collaboration
                    </div>
                    <div className={styles.feature}>
                        <img src="./images/featuresTick.svg" alt="" /> Chat with
                        others
                    </div>
                    <div className={styles.feature}>
                        <img src="./images/featuresTick.svg" alt="" /> Team
                        Creation
                    </div>
                    <div className={styles.feature}>
                        <img src="./images/featuresTick.svg" alt="" /> Easy
                        Event Forms
                    </div>
                    <div className={styles.feature}>
                        <img src="./images/featuresTick.svg" alt="" /> College
                        Updates
                    </div>
                    <div className={styles.feature}>
                        <img src="./images/featuresTick.svg" alt="" /> Event
                        Updates
                    </div>
                </div>
            </div>
        </div>
    );
}

function CallToAction() {
    return (
        <div className={styles.callToActionContainer}>
            <h2>What Are You Waiting For?</h2>
            <p>
                Join Us and give a kickstart to your college life as well as
                your career{" "}
            </p>
            <Link to="/signup">Get Started</Link>
        </div>
    );
}

function OurTeam() {
    return (
        <div className={styles.ourTeamContainer} id="ourTeamContainer">
            <h2>Our Hard Working Team</h2>
            <p>Team</p>
            <div className={styles.cardsContainer}>
                {team.map((each) => {
                    return (
                        <div className={styles.card}>
                            <img src={each.image} alt="" />
                            <div>
                                <h2>{each.name}</h2>
                                <h4>{each.post}</h4>
                                <h5>{each.role}</h5>
                                <p>{each.description}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

// function ContactUs() {
//   return (
//     <div className={styles.contactUsContainer} id="contactUsContainer"></div>
//   );
// }

// function Footer() {
//   return <div className={styles.footerContainer}></div>;
// }

function Copyright() {
    return (
        <div className={styles.copyrightContainer}>
            <p>
                © 2021 <b>OneClick</b>, Inc. All rights reserved.
            </p>
            <img
                className={styles.footerStripeLeft}
                src="./images/footer_stripe_left.svg"
                alt=""
            />
            <img
                className={styles.footerStripeRight}
                src="./images/footer_stripe_right.svg"
                alt=""
            />
        </div>
    );
}

function Landingpage(props) {
    return (
        <div className={styles.container}>
            <NavBar />
            <HeroSection />
            <Offerings />
            <WhyChooseUs />
            <CallToAction />
            <OurTeam />
            {/* <ContactUs />
      <Footer /> */}
            <Copyright />
        </div>
    );
}

export default Landingpage;
export { Copyright };
